import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
    const authToken = localStorage.getItem("authToken");

    return authToken ? <Outlet /> : <Navigate to="/dealer-login" replace />;
};

export default ProtectedRoute;
